<div
  class="textarea"
  [class.textarea--disabled]="disabled()"
  [class.textarea--error]="isErrorShown()"
>
  @if (label()) {
    <label [for]="id" class="textarea__label">
      {{ label() }}
      @if (required()) {
        *
      }
    </label>
  }

  <div class="textarea__field">
    <textarea
      #textareaElement
      class="scroll-primary"
      [id]="id"
      [value]="value() ?? ''"
      [placeholder]="placeholder()"
      [attr.maxlength]="maxLength() ?? null"
      [disabled]="disabled()"
      (input)="value.set(textareaElement.value)"
      (blur)="touch.emit()"
    ></textarea>
  </div>
  @if (maxLength(); as max) {
    <div
      class="typography-labels-2 tw:mt-1.5 tw:self-end tw:tabular-nums"
      [class.tw:text-gray-2]="!isOverLimit()"
      [class.tw:text-red]="isOverLimit()"
      data-testid="textarea-counter"
    >
      {{ length() }}/{{ max }}
    </div>
  }
  @if (isErrorVisible()) {
    <div>
      <fr8bot-ui-validation-error [error]="error()" />
      @if (errorRef()) {
        <ng-content />
      }
    </div>
  }
</div>
